import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/cutehub/Main.vue";
import Browse from "@/components/cutehub/Browse.vue";
import Profile from "@/components/cutehub/Profile.vue";
import HotPicks from "@/components/cutehub/HotPicks.vue";
import Popular from "@/components/cutehub/Popular.vue";
import Category from "@/components/cutehub/browse/Category.vue";
import Subcategory from "@/components/cutehub/browse/Subcategory.vue";
import DetailPage from "@/components/cutehub/DetailPage.vue";
import Login from "../components/authentication/cutehub/Login.vue";
import Contact from "../components/cutehub/Contact.vue";
import Feedback from "../components/cutehub/Feedback.vue";
import Unsubscription from "../components/cutehub/Unsubscription.vue";
import PrivacyPolicy from "../components/cutehub/PrivacyPolicy.vue";
import Terms from "../components/cutehub/Terms.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  hash: false,
  history: true,
  routes: [
    {
      path: "/home",
      name: "Main",
      component: Main,
      children: [
        {
          path: "/home/:token"
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      children: [
        {
          path: "/logout"
        }
      ]
    },
    {
      path: "/browse",
      name: "Browse",
      component: Browse,
      children: [
        {
          path: "/browse/:token"
        }
      ]
    },
    {
      path: "/hotpicks",
      name: "HotPicks",
      component: HotPicks,
      children: [
        {
          path: "/hotpicks/:token"
        }
      ]
    },
    {
      path: "/popular",
      name: "Popular",
      component: Popular,
      children: [
        {
          path: "/popular/:token"
        }
      ]
    },
    {
      path: "/contact",
      name: "Contact",
      component: Contact,
      children: [
        {
          path: "/contact/:token"
        }
      ]
    },
    {
      path: "/feedback",
      name: "Feedback",
      component: Feedback,
      children: [
        {
          path: "/feedback/:token"
        }
      ]
    },
    {
      path: "/privacy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      children: [
        {
          path: "/privacy/:token"
        }
      ]
    },
    {
      path: "/terms",
      name: "Terms",
      component: Terms,
      children: [
        {
          path: "/terms/:token"
        }
      ]
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile,
      children: [
        {
          path: "/profile/:token"
        }
      ]
    },
    {
      path: "/detail/:id",
      name: "DetailPage",
      component: DetailPage,
      children: [
        {
          path: "/detail/:id/:token"
        }
      ]
    },
    {
      path: "/subcategory/:category/:subcat",
      name: "Subcategory",
      component: Subcategory,
      children: [
        {
          path: "/subcategory/:category/:subcat/:token"
        }
      ]
    },
    {
      path: "/category/:category",
      name: "Category",
      component: Category,
      children: [
        {
          path: "/category/:category/:token"
        }
      ]
    },
    {
      path: "/unsubscription",
      name: "Unsubscription",
      component: Unsubscription,
    },
    {
      path: '/:token',
      name: 'Main',
      component: Main
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/cutehub.js